import { IdentityStatus } from '@features/applications/types/identity-status.ts';

export const identityIsOfStatus = (status: IdentityStatus) => {
  return (identityStatus: IdentityStatus) => {
    return identityStatus === status;
  };
};

export const identityFailed = identityIsOfStatus('failed');
export const identityPassed = identityIsOfStatus('passed');
export const identityNotStarted = identityIsOfStatus('not_started');

export const identityComplete = (status: IdentityStatus) => {
  return !identityFailed(status) && !identityNotStarted(status);
};
